import { useAuthStore } from '@/stores/auth';

export default {
  install(app) {
    // Agregar un mixin global para componentes que necesiten autenticación
    app.mixin({
      methods: {
        // Métodos globales para autenticación
        $logout() {
          const authStore = useAuthStore();
          authStore.logout();
        },
        $cerrarSesion() {
          const authStore = useAuthStore();
          authStore.cerrarSesion();
        },
        $inicializarAuth() {
          const authStore = useAuthStore();
          return authStore.inicializarAuth();
        }
      }
    });
  }
}; 